import * as firebase from 'firebase';
import config from '../config/index';

const fireBaseApp = config.firebase && firebase.initializeApp(config.firebase);

export const fireBaseDatabase = fireBaseApp && fireBaseApp.database();



// WEBPACK FOOTER //
// ./helpers/firebase.helper.js